const ThemeSwitcher = () => {
    return null;
};

export default ThemeSwitcher;
